export default "__VITE_ASSET__ChIO18wA__"